import clsx from "clsx";

function FormErrorMessage({
  errors,
  ...props
}: React.HTMLAttributes<HTMLElement> & { errors?: ArrayLike<{ message: string } | undefined> }) {
  return errors ? (
    <p
      role="alert"
      className={clsx("text-[0.8rem] font-medium text-destructive", props.className)}
      {...props}
    >
      {Array.from(errors)
        .filter((error) => error !== undefined)
        .map((error) => error?.message)
        .join(", ")}
    </p>
  ) : (
    <></>
  );
}

export default FormErrorMessage;
